import React from "react";
import { Calendar, Clock } from "lucide-react";

const BookingSummary = ({ tutor, selectedDate, selectedTime, formattedDate, onContinue, isPaymentEnabled }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-md p-8">
      <h3 className="text-gray-900 font-semibold mb-4">Booking Summary</h3>

      <div className="space-y-4 text-sm">
        <div>
          <p className="text-gray-500">Tutor</p>
          <p className="font-medium text-gray-900">{tutor.name}</p>
        </div>

        <div>
          <p className="text-gray-500">Date</p>
          <p className="font-medium text-gray-900">{formattedDate}</p>
        </div>

        <div>
          <p className="text-gray-500">Time</p>
          <p className="font-medium text-gray-900">
            {selectedTime || "Not selected"}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Duration</p>
          <p className="font-medium text-gray-900">60 minutes</p>
        </div>
      </div>

      <div className="mt-6 bg-gray-50 rounded-xl p-4 border border-gray-200">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Session Fee</span>
          <span className="font-medium text-gray-900">${tutor.price}</span>
        </div>

        <div className="flex justify-between mt-2 text-sm">
          <span className="text-green-600 font-medium">Total Amount</span>
          <span className="text-green-600 font-medium">${tutor.price}</span>
        </div>
      </div>

      <button
        onClick={onContinue}
        className={`mt-8 w-full py-3 rounded-xl shadow-md font-medium transition
          ${
            isPaymentEnabled
              ? "bg-[#0736D6] text-white hover:bg-[#062FC0]"
              : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }
        `}
        disabled={!isPaymentEnabled}
      >
        Continue to Payment
      </button>
    </div>
  );
};

export default BookingSummary;